export const RevenueShareFormField = {
  revenueShareEnabled: 'revenueShareEnabled',
  revenueShareValue: 'revenueShareValue',
  revenueShareType: 'revenueShareType',
  revenueShareReportEnabled: 'revenueShareReportEnabled',
} as const;
